import axios from "axios";
import authManager from "../authManager";



export const getProductsApi = async (
  page = 1,
  limit = 30,
  filters = {},
  v = "v1",
  id =null
) => {
  const { data } = await axios.post(`${process.env.REACT_APP_BASE_URL}api/user/${v}/getVendorProducts/${id}`,
    {
      page,
      limit,
      paginate: true,
      filters,
      sortField: "createdAt",
      sortOrder: "desc",
    },
    {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }
  );

  return data?.data;
};